import { Alert, AlertTitle } from '@mui/material';

type CalendarConnectNoticeProps = {
  connected?: boolean;
};

const CalendarConnectNotice = ({ connected }: CalendarConnectNoticeProps): JSX.Element | null => {
  if (connected !== false) {
    return null;
  }

  return (
    <Alert
      severity="info"
      sx={{
        alignItems: 'center',
        '& .MuiAlert-message': { width: '100%' },
      }}
    >
      <AlertTitle
        sx={{
          mt: 1,
        }}
      >
        Calendar not connected: <span>Connect Google Calendar to create or update events.</span>{' '}
      </AlertTitle>
    </Alert>
  );
};

export default CalendarConnectNotice;
